
import { EConsentResponse, TcpaConsentResponse } from '@ld.consumer-portal/models';
import { EndpointScenarioMap } from './mock.types';

export const econsentScenarios: EndpointScenarioMap<EConsentResponse> = {
  default: {
    consentGiven: false,
    borrowerId: 'borrower-001',
    loanId: 'loan-001',
  },
  consented: {
    consentGiven: true,
    consentDate: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(),
    borrowerId: 'borrower-001',
    loanId: 'loan-001',
  },
  'needs-consent': {
    consentGiven: false,
    borrowerId: 'borrower-001',
    loanId: 'loan-001',
  },
};

export const tcpaConsentScenarios: EndpointScenarioMap<TcpaConsentResponse> = {
  default: {
    isLoanConsented: false,
    isBorrowerConsented: false,
  },
  consented: {
    isLoanConsented: true,
    isBorrowerConsented: true,
  },
  'needs-consent': {
    isLoanConsented: false,
    isBorrowerConsented: false,
  },
};
